import { SignRegistrationForSignatoriesFragment } from "gql/graphql";
import { List } from "@/shared/data-display/list";
import Card from "@/shared/data-display/card";
import Text from "@/shared/typography/text";
import { useTranslations } from "use-intl";
import { SignSignature } from "@/modules/signing/entities/sign-signature-status";
import { ExternalSignerInfoLabel } from "@/modules/gateway/features/open-external-sign/view/external-external-signer-info-label/external-signer-info-label";
import { InternalSignerInfoLabel } from "@/modules/gateway/features/open-external-sign/view/external-internal-signer-info-label/internal-signer-info-label";

export function Signatories({
  signRegistration,
}: {
  signRegistration: SignRegistrationForSignatoriesFragment;
}) {
  const t = useTranslations("Signing");
  const number = signRegistration.signers.filter(
    (signer) => signer.signed,
  ).length;
  const total = signRegistration.signers.length;

  return (
    <Card
      size={"small"}
      title={t("Signatories")}
      extra={
        <Text as={"span"} type="caption" color="secondary">
          {t("number/total signed", {
            number,
            total,
          })}
        </Text>
      }
    >
      <div className="flex flex-col gap-3">
        <List
          split={false}
          dataSource={signRegistration.signers}
          renderItem={(signerInfo) => (
            <List.Item>
              <Card size={"small"} className={"w-full"}>
                <div className={"grid gap-y-2"}>
                  {signerInfo.__typename === "InternalSignerInfoDto" && (
                    <InternalSignerInfoLabel
                      externalInternalSignerInfo={signerInfo}
                    />
                  )}

                  {signerInfo.__typename === "ExternalSignerInfoDto" && (
                    <ExternalSignerInfoLabel
                      externalExternalSignerInfo={signerInfo}
                    />
                  )}

                  <div className={"flex flex-wrap items-center gap-2"}>
                    <SignSignature.StatusTag status={signerInfo.status} />
                    <SignSignature.Rejection data={signerInfo} />
                  </div>
                </div>
              </Card>
            </List.Item>
          )}
        />
      </div>
    </Card>
  );
}
